import { Field } from "formik";
import { IWidgetNestedProps } from "../interfaceWidgetTypes";

/**
 * Renders a textarea input component for a diret use in {@link InterfaceWidget | 'InterfaceWidget'}.
 * @category Atom
 */
export function InterfaceWidgetTextArea(props: IWidgetNestedProps) {
  const { disabled, name, label, placeholder } = props;
  return (
    <div data-testid="widget-textarea-input">
      {label && <span className="text-sm text-gray-600">{label}</span>}
      <Field
        placeholder={placeholder}
        name={name}
        className="w-full px-2 text-slate-600 sm:text-sm border-gray-300 rounded-md shadow-sm"
        disabled={disabled}
        as="textarea"
        rows="4"
      ></Field>
    </div>
  );
}
